import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import HomePage from './components/HomePage/HomePage';
import DiamondsDetailPage from './components/Diamonds/DiamondsDetailPage';
import ArtisanDetailPage from './components/Artisans/ArtisanDetailPage';
import LeadershipDetailPage from './components/Leadership/LeadershipDetailPage';
import GradingSystemsPage from './components/GradingSystems/GradingSystemsPage';
import CertificationsPage from './components/Certifications/CertificationsPage';
import ContactUsPage from './components/ContactUs/ContactUsPage';
import LoginPage from './components/Auth/LoginPage';
import BusinessPrinciplesPage from './components/BusinessPrinciples/BusinessPrinciplesPage';
import TermsAndConditionsPage from './components/TermsAndConditions/TermsAndConditionsPage';
import GlobalPresencePage from './components/GlobalPresence/GlobalPresencePage';
import RoughToPolishPage from './components/Process/RoughToPolishPage';
import ScrollToTop from './components/shared/ScrollToTop';

function AppShell() {
  const location = useLocation();
  const hideFrame = location.pathname === '/login';
  return (
    <div className="App">
      {!hideFrame && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/diamonds" element={<DiamondsDetailPage />} />
          <Route path="/artisans" element={<ArtisanDetailPage />} />
          <Route path="/leadership" element={<LeadershipDetailPage />} />
          <Route path="/grading" element={<GradingSystemsPage />} />
          <Route path="/certifications" element={<CertificationsPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/business-principles" element={<BusinessPrinciplesPage />} />
          <Route path="/terms" element={<TermsAndConditionsPage />} />
          <Route path="/global-presence" element={<GlobalPresencePage />} />
          <Route path="/process" element={<RoughToPolishPage />} />
        </Routes>
      </main>
      {!hideFrame && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppShell />
    </Router>
  );
}

export default App;
